import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { FormWrapperLabel, useTranslation } from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef } from 'react';
import { SearchTypesType } from '../SearchControlTypes';

function SearchMailTerm(props: SearchTypesType) {
	const { t } = useTranslation();

	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = props.searchParams?.get('term') ? (props.searchParams.get('term') as string) : '';
		}
	}, [props.searchParams]);

	return (
		<Controller
			name='term'
			control={props.formMethods.control}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={t('mailboxes.filter.labels.textSearch')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<input
						type='text'
						onChange={(e: any) => {
							field.onChange(e.currentTarget.value);
						}}
						defaultValue={props.searchParams?.get('term') as string}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { SearchMailTerm };
